import team from './team';
import services from './services';
import products from './products';
import blogs from './blogs';
import events from './events';
import { positions } from './career';
import caseStudies from './cases';



const navbar = [
    {
        id: 1,
        mainLink : {link: '/', title: 'home'},
        subLink: [],
    },
    {
        id: 2,
        mainLink : {link: '#', title: 'about'},
        subLink: [
            {id: 1, link: '/About-us', title: 'about us'},
            {id: 2, link: '/Team', title: 'team'},
            {id: 3, link: '/Team/TeamSingle', title: 'team single', state: team[0]},
            {id: 4, link: '/Testimonials', title: 'testimonials'},
            {id: 5, link: '/Faqs', title: 'faqs'},
            {id: 6, link: '/Why-Choose-Us', title: 'why choose us'},
        ],
    },
    {
        id: 3,
        mainLink: { title: "Pages", link: "#" },
        subLink: [
            { id: 1, link: "/Gallery", title: "Gallery"  },
            { id: 2, link: "/Get-Quote", title: "Get Quote" },
            { id: 3, link: "/Features", title: "Features" },
            { id: 4, link: "/Pricing", title: "Pricing" },
            { id: 5, link: "/Process", title: "Work Process" },
            {
                id: 6,
                title: "Career",
                children: [
                    { id: 1, link: "/Careers", title: "Careers" },
                    { id: 2, link: "/Careers/Position-Single", title: "Career Single",  state: positions[0] },
                    { id: 3, link: "/Career-Form", title: "Career Form" },
                ],
            },
            {
                id: 7,
                title: "Information Hub",
                children: [
                    { id: 1, link: "*", title: "Error 404" },
                    { id: 2, link: "/Services-Terms", title: "Terms of Services" },
                    { id: 3, link: "/Privacy-Policy", title: "Privacy Policy" },
                ],
            },
            {
                id: 8,
                title: "Event",
                children: [
                    { id: 1, link: "/Events", title: "Events" },
                    { id: 2, link: "/Events/Event-Single", title: "Event Single",  state: events[0] },
                ],
            },
            { id: 9, link: "/Help-Center", title: "Help Center"  },
            { id: 10, link: "/Clients", title: "Clients" },
        ],
    },
    {
        id: 4,
        mainLink : {link: '#', title: 'Service'},
        subLink: [
            { id: 1, link: "/Services", title: "Services" },
            { id: 2, link: "/Services/Service-Single", title: "Service Single",  state: services[0] },
        ],
    },
    {
        id: 5,
        mainLink : {link: '#', title: 'Case'},
        subLink: [
            { id: 1, link: "/Case-Studies", title: "Case Studies" },
            { id: 2, link: "/Case-Studies/Case-Single", title: "Case Single",  state: caseStudies[0] },
        ],
    },
    {
        id: 6,
        mainLink : {link: '#', title: 'blog'},
        subLink: [
            {id: 1, link: '/Blog-grid', title: 'blog grid'},
            {id: 2, link: '/Blog-list', title: 'blog list'},
            {id: 3, link: '/Blogs/Blog-Single', title: 'blog single', state: blogs[0]},
        ],
    },
    {
        id: 7,
        mainLink : {link: '#', title: 'shop'},
        subLink: [
            {id: 1, link: '/Shop-grid', title: 'shop grid'},
            {id: 2, link: '/Shop-list', title: 'shop list'},
            {id: 3, link: '/Shop/Product-Single', title: 'product single', state: products[0]},
            {id: 4, link: '/Wishlist', title: 'wishlist'},
            {id: 5, link: '/Cart', title: 'cart'},
            {id: 6, link: '/Checkout', title: 'checkout'},
            {id: 7, link: '/OrderConfirmation', title: 'Order Confirmation'},
            {id: 8, link: '/Login', title: 'login'},
            {id: 9, link: '/Register', title: 'register'},
            {id: 10, link: '/Forgot-pwd', title: 'forgot Password'},
        ],
    },
    {
        id: 8,
        mainLink : {link: '/Contact-us', title: 'contact'},
        subLink: [],
    },
];

export default navbar;